<template>
  <div>
    <div class="flex items-center justify-between mt-10 container max-w-screen-xl">
      <a href="/login">
        <el-button type="plain" class="border-brand-gray-blue border-2 px-10 py-2 rounded-lg">
          <span class="text-base text-brand-blue font-bold">Sign In</span>
        </el-button>
      </a>
      <div class="">
        <img src="@/assets/brand/ck-logo.svg" class="h-6 md:h-8 lg:h-8 w-auto inline-block" alt="Logo" />
      </div>
      <div class="hidden md:block">
        <el-button @click="bookDemo" type="primary" class="font-bold py-4 px-6 rounded-lg">Get a Demo →</el-button>
      </div>
    </div>
    <!-- initial page -->
    <div v-if="step === 'initial'" class="bg-brand-sand rounded-none lg:rounded-xl container max-w-screen-xl mt-6 pt-8 lg:pt-16 pb-16 px-12 lg:mt-8">
      <div class="flex flex-col space-y-12 lg:space-y-0 lg:grid lg:grid-cols-2 lg:gap-x-12">
        <!-- LEFT SIDE -->
        <!-- Fast Track LEFT SIDE -->
        <div class="flex flex-col justify-between px-6 space-y-12" v-if="stripeFastTrack">
          <div v-if="verifying">
            <!-- Logos: Churnkey <==> Stripe -->
            <div class="mb-5">
              <img src="@/assets/brand/logo.svg" class="h-6 md:h-8 lg:h-8 w-auto inline-block" alt="Logo" />
              <img src="@/assets/img/two-way-arrows.svg" class="h-3 px-5 md:h-4 lg:h-4 w-auto inline-block" alt="Logo" />
              <img src="@/assets/img/stripe.svg" class="h-6 md:h-8 lg:h-8 w-auto inline-block" alt="Logo" />
            </div>
            <p class="text-2xl font-bold">Authenticating your Stripe Account...</p>
          </div>
          <div v-if="!verifying">
            <!-- Logos: Churnkey <==> Stripe -->
            <div class="mb-5">
              <img src="@/assets/brand/logo.svg" class="h-6 md:h-8 lg:h-8 w-auto inline-block" alt="Logo" />
              <img src="@/assets/img/two-way-arrows.svg" class="h-3 px-5 md:h-4 lg:h-4 w-auto inline-block" alt="Logo" />
              <img src="@/assets/img/stripe.svg" class="h-6 md:h-8 lg:h-8 w-auto inline-block" alt="Logo" />
            </div>
            <p class="text-4xl font-bold">Fast-track your new Churnkey account.</p>
            <p class="mt-4 text-xl font-semibold leading-8 text-brand-brown">
              With Churnkey and Stripe together, you’ll retain more customers, recover more failed payments, and increase customer intelligence.
            </p>
          </div>
        </div>
        <!-- Regular LEFT SIDE -->
        <div class="flex flex-col justify-between px-6 space-y-12" v-else>
          <div>
            <p class="text-4xl font-bold">Get started with Churnkey.</p>
            <p class="mt-4 text-xl font-semibold leading-8 text-brand-brown">
              With Churnkey, you’re able to focus critical resources on attracting new customers. We retain those you’ve already won. Automatically.
            </p>
          </div>
          <div class="hidden lg:block">
            <Testimonial :image="require(`@/assets/img/people/jarvis-headshot.jpg`)">
              Churnkey made it possible for our marketing team to design the best exit funnel to increase LTV, reduce churn, and give us the insights
              to reactivate users.
              <template v-slot:author>
                Austin Distel, <br />
                CMO at Jasper.ai
              </template>
            </Testimonial>
          </div>
        </div>
        <!-- RIGHT SIDE -->
        <div v-if="!(stripeFastTrack && verifying)">
          <div class="relative px-6 sm:px-8 py-8 self-center m-auto bg-white rounded-lg shadow-md w-11/12">
            <el-form
              v-loading="pending"
              :model="signupForm"
              :rules="rules"
              ref="signupForm"
              class="get-started-form brand-input"
              label-position="top"
              label-width="100px"
              @submit.prevent.native="register()"
              id="growth-lever-white-paper-form"
              hide-required-asterisk
            >
              <div class="grid grid-cols-2 gap-x-4">
                <el-form-item label="Full Name" name="Full Name" prop="name" class="font-bold text-left">
                  <el-input placeholder="" v-model="signupForm.name"></el-input>
                </el-form-item>
                <el-form-item label="Work Email" name="Last Name" prop="email" class="font-bold text-left">
                  <el-input placeholder="" v-model="signupForm.email"></el-input>
                </el-form-item>
              </div>
              <div class="grid grid-cols-2 gap-x-4">
                <el-form-item label="New Account Password" name="Password" prop="password" class="font-bold text-left">
                  <el-input placeholder="" v-model="signupForm.password" show-password></el-input>
                </el-form-item>
                <el-form-item label="Confirm Password" name="Confirm Password" prop="confirmPassword" class="font-bold text-left">
                  <el-input placeholder="" v-model="signupForm.confirmPassword" show-password></el-input>
                </el-form-item>
              </div>
              <div class="grid grid-cols-2 gap-x-4">
                <el-form-item label="Company Name" name="Company Name" prop="company" class="font-bold text-left">
                  <el-input placeholder="" v-model="signupForm.company"></el-input>
                </el-form-item>
                <el-form-item label="Your Job Title" class="font-bold text-left" name="Job Title" prop="salesData.jobTitle">
                  <el-input v-model="signupForm.salesData.jobTitle"></el-input>
                </el-form-item>
              </div>
              <div v-if="false" class="el-form-item mt-0">
                <label for="phone" class="el-form-item__label font-bold">Phone Number</label>
                <div class="el-form-item__content">
                  <div class="el-input el-input--suffix">
                    <vue-phone-number-input
                      no-example
                      v-model="signupForm.salesData.phone"
                      :translations="translations"
                      :required="true"
                      error-color="#f7b200"
                      valid-color="#D8DFF6"
                      @update="onPhoneUpdate"
                    ></vue-phone-number-input>
                  </div>
                </div>
              </div>
              <el-form-item label="How did you find Churnkey?" name="source" prop="source" class="font-bold text-left" v-if="!stripeFastTrack">
                <el-input placeholder="" v-model="signupForm.salesData.source"></el-input>
              </el-form-item>
              <el-form-item
                prop="paymentProvider"
                label="What is your primary payment processor?"
                class="font-bold text-left"
                v-if="!stripeFastTrack"
              >
                <el-select v-model="signupForm.paymentProvider" class="w-full" placeholder="e.g. Stripe, Braintree, Chargebee" filterable>
                  <el-option
                    v-for="provider in paymentProviderOptions"
                    :value="provider.value"
                    :label="provider.label"
                    :key="provider.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                prop="salesData.timeframe"
                label="How quickly do you want to start improving retention?"
                class="font-bold text-left"
                v-if="!stripeFastTrack"
              >
                <el-select v-model="signupForm.salesData.timeframe" class="w-full" placeholder="" filterable>
                  <el-option label="Yesterday" value="yesterday">Yesterday!</el-option>
                  <el-option label="This Week" value="this week">This Week</el-option>
                  <el-option label="Next Week" value="next week">Next Week</el-option>
                  <el-option label="Next Month" value="next month">Next Month</el-option>
                </el-select>
              </el-form-item>
              <el-button :loading="pending" @click="register()" type="primary" class="font-bold py-4 text-base px-6 rounded-lg w-full mt-2"
                >Continue →</el-button
              >
            </el-form>
          </div>
          <div class="text-center mt-4 text-sm font-medium">
            <p>
              Or, get a Churnkey demo instead. <span class="text-brand-blue cursor-pointer font-semibold" @click="bookDemo"> Schedule now →</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!stripeFastTrack">
      <div v-if="['initial'].includes(step)" class="mt-6 lg:mt-12 container max-w-screen-lg">
        <p class="font-bold text-2xl text-center">Incredible companies use Churnkey…</p>
        <CustomerLogos />
      </div>
      <div v-else class="mt-6 lg:mt-12 container max-w-screen-lg">
        <p class="font-bold text-lg text-center text-brand-brown">
          <span v-if="step === 'plan'"> Questions? We can walk you through our options.</span>
          <span v-else-if="step === 'connect'"> Don't use Stripe? We can walk you through your options.</span>
          <span v-else> Questions? We're here to help.</span>
        </p>
        <div class="text-center mt-4 pb-2">
          <el-button type="plain" class="border-brand-gray-blue border-2 px-8 py-3 rounded-lg" @click="openChat">
            <span class="text-base text-brand-blue font-semibold">Talk With Us</span>
          </el-button>
        </div>
        <CustomerLogos />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unreachable */
/* eslint-disable no-else-return */
import EventBus from '@/helpers/event-bus';
import * as events from '@/helpers/gtm-events';
import { REGISTER } from '@/store/action-types';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import Testimonial from '@/components/UI/TestimonialAlt.vue';
import CustomerLogos from '@/components/UI/CustomerLogos.vue';
import { isBlacklistedEmail, validateEmail } from '@/helpers/jsUtils';
import AuthService from '@/api/auth.service';

const validateName = (rule, value, callback) => {
  if (!value || value.length === 0) {
    callback(new Error('Please type your first and last name.'));
    return;
  }
  if (value.length && value.trim().split(/\s+/).length < 2) {
    callback(new Error('Please type your first and last name.'));
    return;
  }
  callback();
};

const validateEmailInput = (rule, value, callback) => {
  if (!value) {
    callback(new Error('Email required.'));
    return;
  }
  if (!validateEmail(value)) {
    callback(new Error('Invalid email address.'));
    return;
  }
  if (isBlacklistedEmail(value)) {
    callback(new Error('A work email is required.'));
    return;
  }
  callback();
};

const rules = {
  name: [{ required: true, type: 'string', validator: validateName, trigger: 'change' }],
  email: [{ required: true, type: 'email', validator: validateEmailInput, trigger: 'change' }],
  password: [
    { required: true, type: 'string', message: 'Password is required.' },
    { min: 8, message: '8+ characters.', trigger: 'change' },
  ],
  company: [{ required: true, type: 'string', message: 'You company name is required.' }],
  paymentProvider: [{ required: true, type: 'string', message: 'A subscription billing platform is required.' }],
  salesData: {
    jobTitle: [{ required: true, type: 'string', message: 'Job title is required.', trigger: 'change' }],
    source: [{ required: true, type: 'string', message: 'This is a big help to us, thank you.', trigger: 'change' }],
    primaryGoal: [{ required: true, message: 'Please select your primary goal.', trigger: 'change' }],
    timeframe: [{ required: true, message: 'Please select a timeframe.', trigger: 'change' }],
  },
};

const paymentProviderOptions = [
  { label: 'Stripe', value: 'stripe' },
  { label: 'Braintree', value: 'braintree' },
  { label: 'Chargebee', value: 'chargebee' },
  { label: 'Paddle', value: 'paddle' },
  { label: 'Recurly', value: 'recurly' },
  { label: 'App Store / Google Play', value: 'app' },
  { label: 'Other', value: 'other' },
];

export default {
  name: 'Welcome',
  components: {
    Testimonial,
    CustomerLogos,
  },
  created() {
    if (this.$store.getters.isLoggedIn) {
      this.$router.push('/');
    }
    if (this.$route.query.token) {
      const token = this.$route.query.token;
      this.verifyFastTrackToken(token);
    }
    if (this.$route.query.error) {
      // User tried to use a fast track token and failed (malformed, expired, etc.)
      // Fall back to regular sign up flow, but pre-select Stripe as payment provider:
      // This code is for the case where the user refreshes the page:
      if (['invalid_token', 'token_expired'].includes(this.$route.query.error)) {
        this.stripeFastTrack = false;
        this.signupForm.paymentProvider = 'stripe';
      }
    }
  },
  data() {
    const passwordConfirmValidator = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please confirm password.'));
      } else if (value !== this.signupForm.password) {
        callback(new Error('Passwords do not match.'));
      } else {
        callback();
      }
    };
    return {
      step: 'initial', // initial, plan, payment, meeting, connect
      rules: {
        ...rules,
        confirmPassword: [
          {
            required: true,
            type: 'string',
            validator: passwordConfirmValidator,
            trigger: 'change',
          },
        ],
      },
      signupForm: {
        email: '',
        name: '',
        password: '',
        confirmPassword: '',
        salesData: {
          phone: '',
          jobTitle: '',
          timeframe: '',
          primaryGoal: '',
        },
        company: '',
        paymentProvider: '',
        fastTrackToken: '',
      },
      translations: {
        phoneNumberLabel: 'Enter valid number.',
      },
      paymentProviderOptions,
      pending: false,
      verifying: false, // irrelevant if we didn't receive a fast track token
      audit: false,
      meetingScheduled: false,
      error: '',
      tokenError: '',
      stripeFastTrack: false,
    };
  },
  methods: {
    bookDemo() {
      // eslint-disable-next-line no-undef
      SavvyCal('open', { link: 'churnkey-team/product-demo' });
    },
    // for now we skip forced phone number validation
    onPhoneUpdate(payload) {
      const { formatInternational } = payload;
      this.signupForm.salesData.phone = formatInternational;
    },
    initSavvyCal() {
      // eslint-disable-next-line no-undef
      SavvyCal('inline', { link: 'churnkey-team/retention-strategy', selector: '#booking-page', theme: 'light' });
      window.addEventListener('savvycal.scheduled', (ev) => {
        // The `detail` property contains the following data about the newly-scheduled event:
        //   id, startAt, endAt, email, displayName, fields, phoneNumber, timeZone, guests
        const data = ev.detail;
        this.meetingScheduled = true;
        // Do something with the data...
      });
    },
    async verifyFastTrackToken(token) {
      this.verifying = true;
      this.stripeFastTrack = true;
      try {
        const {
          decoded: { accountData = {}, stripeAccountId },
        } = await AuthService.verifyFastTrackToken(token);
        const { company, name, email } = accountData;
        this.signupForm.paymentProvider = 'stripe';
        if (company) this.signupForm.company = company;
        if (name) this.signupForm.name = name;
        if (email) this.signupForm.email = email;
        this.signupForm.fastTrackToken = token; // instead of passing the stripeAccountId, pass the token for added security
        // the server can decode it again when submitting and find the stripeAccountId
      } catch (err) {
        const msg = err?.response?.data?.message;
        console.log('Error verifying fast track token:', msg, err);
        this.stripeFastTrack = false; // Fall back to regular sign up flow
        this.signupForm.paymentProvider = 'stripe'; // Pre-select Stripe

        // Catch some specific problems with token in case we want to deal with them differently in the future:
        if (msg && ['invalid signature', 'jwt malformed', 'invalid token'].includes(msg)) {
          this.tokenError = 'invalid_token';
          this.$router.push({ path: '/register?error=invalid_token' });
        }
        if (msg === 'jwt expired') {
          this.tokenError = 'expired_token';
          this.fastTrackToken = null;
          this.$router.push({ path: '/register?error=expired_token' });
        }
        this.error = err.response.data.message;
      } finally {
        this.verifying = false;
      }
    },
    async register() {
      // check for audit
      this.audit = !!localStorage.getItem('audit');
      this.pending = true;
      try {
        this.$refs.signupForm.validate(async (valid) => {
          if (valid) {
            await this.$store.dispatch(REGISTER, { ...this.signupForm, churnAudit: this.audit });
            if (this.$store.state.authStatus === 'success') {
              // Track conversion event
              EventBus.$emit('trackEvent', { ...events.signedUp, user: this.signupForm.email });
              if (this.$store.state.productIntent === 'dunning') {
                this.$router.push('/get-started/connect-stripe-dunning');
              } else {
                this.$router.push('/get-started');
              }
            } else {
              this.$message.error('Invalid user registration.');
            }
          } else {
            console.log('form not valid');
          }
          this.pending = false;
        });
      } catch (error) {
        // invalid form
        console.log(error);
        this.error = error;
        this.pending = false;
      }
    },
    goToLogin() {
      this.$router.push('/login');
    },
    openChat() {
      EventBus.$emit('openChat');
    },
  },
};
</script>
<style lang="scss">
#MazPhoneNumberInput {
  @apply space-x-4;
  label.input-tel__label {
    line-height: 16px !important;
  }
  label.country-selector__label {
    line-height: 16px !important;
  }
  input.input-tel__input,
  input.country-selector__input {
    border-radius: 3px !important;
    @apply ring-brand-medium-blue;
    /* ring width 3 */
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
    @apply text-brand-blue;
    @apply font-medium;
    @apply border-none;
    @apply placeholder-white;
    @apply cursor-text;
  }
}

.get-started-form {
  .el-form--label-top .el-form-item__label {
    padding: 0;
    line-height: 34px;
  }

  &.el-form .el-form-item .el-input__inner:focus {
    border-color: #3c5ccf;
  }

  &.el-form .el-form-item.is-error .el-input__inner {
    @apply border-brand-yellow;
  }

  &.el-form .el-form-item__error {
    @apply text-brand-yellow;
    left: inherit;
    right: 0;
    padding-top: 5px;
    font-weight: 600;
  }

  .el-form-item {
    margin-bottom: 20px;
  }
}
</style>
